import { xBaseTheme } from "@stoneage/XDL/types";

export default {
    defaultProps: {
        color: "primary",
    },
} as xBaseTheme["loadingSpinner"];
